<template>
  <div class="complete_content">
    <dd-header
      :headerType=1
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>登録完了</h2>
        </div>
        <div class="main_content">
          <ul class="thanks">
            <li>ご登録ありがとうございました。</li>
            <li>登録完了メールを自動送信しました。</li>
          </ul>
          <ul class="for_mail">
            <li>※受信制限をされている方は、「<label class="weighty">@domans.co.jp</label>」からのメールを受信許可に設定してください</li>
            <li>※メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。</li>
          </ul>
        </div>
        <div id="login">
          <div id="login_icon">
            <div>
              <img :src="getImage('common/logo.png')">
            </div>
            <div>
              <label>My size, My lifestyle.</label>
            </div>
          </div>
          <div class="regist_form">
            <dd-login></dd-login>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Module
import Header from '../components/common/DcHeader'
import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'
import LoginForm from '../components/login/LoginForm'

export default {
  name: 'Login',
  components: {
    'dd-header': Header,
    'dd-login': LoginForm
  },
  data () {
    return {
      form: {
        loginId: '',
        password: ''
      },
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        loginId: '',
        password: ''
      }
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  created () {
    App.removeLocalStorage(DC_STORAGE_KEY.INVITE_CODE)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>
<style src="../css/login.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/RegistUserComplete.vue